import { z } from 'zod';

export const ConfigValidator = z.object({
  fe: z.object({
    displayNameDescriptorField: z.object({
      default: z.string(),
      types: z.record(z.string()).optional(),
    }),
  }),
});

export type ConfigSchema = z.infer<typeof ConfigValidator>;

export const defaultConfig: DeepPartial<ConfigSchema> = {
  fe: {
    displayNameDescriptorField: {
      default: 'name',
    },
  },
};

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
